import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SecurityNotice = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="flex items-start gap-3 bg-[#EFF6FF] border border-[#BFDBFE] rounded-xl px-4 py-3 mb-4">
      <svg
        className="w-4 h-4 text-[#1D4ED8] mt-0.5 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
      <p className="text-[11px] text-[#1D4ED8] leading-relaxed flex-1">
        {t('admin.reporting.webhooks.securityNotice')}
      </p>
      <button
        onClick={() => setDismissed(true)}
        className="text-[#1D4ED8] opacity-50 hover:opacity-100 transition-opacity shrink-0 mt-0.5"
        aria-label="Dismiss"
      >
        <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default SecurityNotice;
